<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <template v-if="!page">
            <div v-if="institutionLogoUrl" class="z-card z-card--small onboarding__logo-wrapper">
              <img :src="require(`assets/images/queropago.svg`)" class="onboarding__logo">
              <div class="onboarding__logo-separator"></div>
              <img :src="institutionLogoUrl" class="onboarding__logo">
            </div>

            <div class="z-title z-title--small">
              Você já conhece o Quero Pago?
            </div>
            <p class="z-text spacer-bottom-l">
              Com o Quero Pago você se liberta da secretaria da {{ currentBilling.institution_name }}, foge das filas,
              papelada e burocracia. Queremos que você se preocupe apenas com suas notas,
              o resto, a gente resolve.
            </p>

            <button @click="start" class="z-button z-button--primary z-button--block spacer-bottom-l">
              Veja as vantagens
            </button>

            <a @click.prevent="skipOnboarding" class="z-link z-link--center z-link--block">Pular introdução</a>
          </template>
          <template v-else>
            <div class="z-card z-card--large z-card--only-desktop onboarding__page-wrapper">
              <onboarding-page
                :illustration="page.illustration"
                :title="page.title"
                :text="page.text"
                class="spacer-bottom-l"
              />

              <div class="onboarding__float-controls">
                <div class="z-button-wrapper">
                  <button @click="changePage(1)" class="z-button z-button--primary z-button--block">
                    {{ nextPageText }}
                  </button>

                  <button @click="changePage(-1)" class="z-button z-button--secondary z-button--block">
                    Anterior
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.onboarding__logo-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: var(--space-extra-large);

  @media (min-width: $screen-md-min) {
    margin-bottom: var(--space-jumbo);
  }
}

.onboarding__logo {
  max-height: 44px;
}

.onboarding__logo-separator {
  border: 1px solid var(--color-neutral-lighter-gray);
  height: 42px;
  margin-left: var(--space-medium);
  margin-right: var(--space-medium);
  width: 2px;
}

.onboarding__page-wrapper {
  margin-bottom: var(--space-giant);

  @media (min-width: $screen-md-min) {
    margin-bottom: 0;
  }
}

.onboarding__float-controls {
  background-color: var(--color-neutral-sugar);
  bottom: 0;
  box-shadow: var(--parameter-elevation-00);
  left: 0;
  padding: var(--space-small) var(--space-medium);
  position: fixed;
  width: 100%;

  @media (min-width: $screen-md-min) {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
    position: static;
  }
}

.z-link--block {
  display: block;
}

.z-link--center {
  text-align: center;
}

.z-card--only-desktop {
  @media (max-width: $screen-sm-max) {
    background-color: unset;
    box-shadow: unset;
    padding: unset;
    transition: unset;
  }
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import DashboardService from 'services/DashboardService';
import Onboarding from 'utils/onboarding';
import OnboardingPage from './page';

export default {
  components: {
    OnboardingPage,
  },
  computed: {
    ...mapState([
      'currentBilling',
    ]),
  },
  data() {
    return {
      onboarding: new Onboarding(),
      pages: [],
      current: null,
      institutionLogoUrl: null,
      page: null,
      nextPageText: 'Próximo',
    };
  },
  methods: {
    ...mapActions([
      'loadStudent',
      'loadBillings',
    ]),
    start() {
      [this.page] = this.pages;
      this.current = 0;
    },
    skipOnboarding() {
      this.$tracker.logEvent('[onboarding] Skipped');
      this.finish();
    },
    finish() {
      return DashboardService.updateOnboardingDone()
        .then(() => this.loadStudent())
        .then(() => this.loadBillings())
        .then(() => {
          if (!this.currentBilling.configured) {
            this.$router.push({ name: 'payment-configuration' });
          } else {
            this.$router.push({ name: 'panel' });
          }
        });
    },
    totalPages() {
      return this.pages.length;
    },
    changePage(pointer) {
      const nextPage = this.current + pointer;

      if (nextPage === -1) {
        this.page = null;
        return false;
      }

      if (nextPage >= this.totalPages()) {
        this.$tracker.logEvent('[onboarding] Finished');
        return this.finish();
      }

      return this.updatePage(nextPage);
    },
    updatePage(nextPage) {
      this.current = nextPage;
      this.page = this.pages[nextPage];

      const lastPageActive = this.page === this.pages[this.totalPages() - 1];

      if (lastPageActive) {
        this.nextPageText = 'Começar';
      } else {
        this.nextPageText = 'Próximo';
      }
    },
  },
  mounted() {
    this.pages = this.onboarding.pages;

    DashboardService
      .getInstitution(this.currentBilling.institution_id)
      .then((institution) => this.institutionLogoUrl = institution.logo_url)
      .catch((error) => this.$rollbar.error(error));

    this.$tracker.logEvent('Viewed Onboarding Page');
  },
};
</script>
